import React, { useCallback } from "react";
import type { ReactNode } from "react";
import ErrorBoundaryClass from "./ErrorBoundaryClass";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

const ErrorBoundary: React.FC<Props> = ({ children, fallback, onError }) => {
  const handleError = useCallback(
    (error: Error, errorInfo: React.ErrorInfo) => {
      // Call the provided error handler
      if (onError) {
        onError(error, errorInfo);
      }
    },
    [onError]
  );

  return (
    <ErrorBoundaryClass fallback={fallback} onError={handleError}>
      {children}
    </ErrorBoundaryClass>
  );
};

export default ErrorBoundary;
